<template>
  <q-btn
    unelevated
    rounded
    color="primary"
    text-color="white"
    size="md"
  ><slot /></q-btn>
</template>
